/*=========================================================================================
  File Name: moduleSettingsGetters.js
  Description: Getters of the settings module.
==========================================================================================*/

export default {
}
